import React from 'react';
import { useMediaQuery } from '@mui/material';
import Facebook from '../images/facebook.png';
import Instagram from '../images/instagram.png';
import X from '../images/x.png';
import Youtube from '../images/youtube.png';

function RedesSociais() {
  const isMobile = useMediaQuery('(max-width:800px)');

  const redesSociais = [
    { nome: 'Facebook', imagem: Facebook, url: 'https://www.facebook.com/portalcnm/?locale=pt_BR' },
    { nome: 'Instagram', imagem: Instagram, url: 'https://www.instagram.com/portalcnm/' },
    { nome: 'X', imagem: X, url: 'https://twitter.com/portalcnm' },
    { nome: 'Youtube', imagem: Youtube, url: 'https://www.youtube.com/user/tvportalcnm' },
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <div style={{ marginLeft: 'auto' }}>
        {redesSociais.map((rede) => (
          <a key={rede.nome} href={rede.url} target="_blank" rel="noopener noreferrer">
            <img
              src={rede.imagem}
              alt={`Ícone do ${rede.nome}`}
              style={{
                width: isMobile ? '45px' : '50px',
                height: isMobile ? '45px' : '50px',
                margin: '0 10px',
              }}
            />
          </a>
        ))}
      </div>
    </div>
  );
}

export default RedesSociais;
